import React from 'react';
import Icon from '../../../components/AppIcon';

const LeaderboardSection = ({ leaderboardData, activeCategory, onCategoryChange }) => {
  const categories = ['Todos', 'Artes', 'Vídeos'];

  const getRankIcon = (rank) => {
    if (rank === 1) return { name: 'Trophy', color: 'var(--color-primary)' };
    if (rank === 2) return { name: 'Medal', color: 'var(--color-secondary)' };
    if (rank === 3) return { name: 'Award', color: 'var(--color-accent)' };
    return { name: 'Star', color: 'var(--color-muted-foreground)' };
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 lg:p-8 glow-primary">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-primary">
          Ranking de Performance
        </h2>
        
        <div className="flex items-center gap-2 overflow-x-auto">
          {categories?.map((category) => (
            <button
              key={category}
              onClick={() => onCategoryChange(category)}
              className={`px-4 py-2 rounded-md font-medium text-sm md:text-base whitespace-nowrap transition-smooth flex-shrink-0 ${
                activeCategory === category
                  ? 'bg-primary text-primary-foreground glow-primary'
                  : 'bg-muted text-foreground hover:bg-muted/80 hover:glow-primary-hover'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>
      <div className="space-y-3 md:space-y-4">
        {leaderboardData?.map((item, index) => {
          const rankIcon = getRankIcon(index + 1);
          return (
            <div
              key={item?.id}
              className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-background rounded-md border border-border transition-smooth hover:border-primary hover:glow-primary-hover"
            >
              <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 flex-shrink-0">
                <Icon name={rankIcon?.name} size={24} color={rankIcon?.color} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading font-bold text-foreground text-sm md:text-base lg:text-lg line-clamp-1">
                  {item?.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs md:text-sm text-muted-foreground line-clamp-1">
                    {item?.category}
                  </span>
                  <span className="text-xs text-muted-foreground">•</span>
                  <span className="text-xs md:text-sm text-muted-foreground">
                    {item?.date}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-4 md:gap-6 flex-shrink-0">
                <div className="flex items-center gap-1.5">
                  <Icon name="Star" size={16} color="var(--color-primary)" fill="var(--color-primary)" />
                  <span className="font-bold text-primary text-sm md:text-base whitespace-nowrap">
                    {item?.rating?.toFixed(1)}
                  </span>
                </div>
                <div className="hidden sm:flex items-center gap-1.5">
                  <Icon name="Eye" size={16} color="var(--color-secondary)" />
                  <span className="text-sm text-foreground whitespace-nowrap">
                    {item?.views}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LeaderboardSection;